// extracted by mini-css-extract-plugin
export var navbarSubLink = "J_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "J_vl d_f0 d_dB";
export var subPageLink = "J_gf d_gf";
export var burger = "J_wB";
export var sublinkSize = "J_wC";
export var linkSize = "J_wD";
export var Link = "J_tQ z_tQ z_s2 z_tm";